import mixPanelService from "./trackers/mixpanel";
var setup = function (env) {
    mixPanelService.setup(env);
};
export default {
    setup: setup
};
